import { writable } from 'svelte/store';

const createFormData = () => {
  const { subscribe, set, update } = writable({});
  const storageStr = 'feedbackData';

  const reset = () => {
    localStorage.setItem(storageStr, JSON.stringify({}));
    localStorage.removeItem('currentPage');
    set({});
  };

  const updateFormData = (newData) => {
    update((n) => {
      const updated = { ...n, ...newData };
      updateLocalStorage(updated);
      return updated;
    });
  };

  const updateLocalStorage = (newData) => {
    const json = JSON.stringify(newData);
    localStorage.setItem(storageStr, json);
  };

  const fetchLocalStorage = () => {
    const json = localStorage.getItem(storageStr);
    return !!json ? JSON.parse(json) : null;
  };

  const storageData = fetchLocalStorage();

  if (!!storageData) {
    set(storageData);
  } else {
    updateLocalStorage({});
  }

  return {
    subscribe,
    updateFormData,
    reset,
  };
};

export const formData = createFormData();
